import { FingerIcon, LogoIcon, SignUpIcon2, SmsIcon } from 'assets/svgComponent';
import BackLayout from 'component/BackLayout/index';
import styles from './auth.module.scss';
import Login from './login/login';
import { useEffect, useState } from 'react';
import { useRedux } from 'redux/useRedux';
import SignUp from './signup/signup';
import Otp from './otp/otp';
import ForgetPassword from './forgetPassword';
import ChangePassword from './changePassword';
import { useSearchParams } from 'react-router-dom';
import { onChangeAuth } from './redux';
const Auth = () => {
    const { dispatch, authState } = useRedux()
    const [refresh, setRefresh] = useState(false)
    const [searchParams] = useSearchParams();
    useEffect(() => {
        //comment dar sms in miad
        if (searchParams.get('f')==='true') {
            dispatch(onChangeAuth("status","forgetPassword"))
        }
    }, [])
    return (
        <BackLayout dashboard={false}  >

            <div className={["centerSelf", styles.mainDiv].join(" ")}>
                <div className={[styles.formDiv].join(" ")}>
                    <div onClick={()=>{window. open("https://www.investo.ir", "_blank")}} className={styles.divLogo} >
                        <LogoIcon  />
                    </div>
                    {<div style={{ display: authState.status === "login" ? "block" : "none" }}> <Login /></div>}
                    {<div style={{ display: authState.status === "signUp" ? "block" : "none" }}> <SignUp /></div>}
                    {/* {<div style={{ display: authState.status === "forgetPassword" ? "block" : "none" }}> <ForgetPassword /></div>} */}
                    {<div style={{ display: authState.status === "changePassword" ? "block" : "none" }}> <ChangePassword /></div>}
                    {authState.status === "otp" && <Otp />}

                </div>
                <div className={[styles.viewDiv].join(" ")}>
                    {authState.status === "login" && <FingerIcon className={styles.logo} />}
                    {authState.status === "forgetPassword" && <FingerIcon className={styles.logo} />}
                    {authState.status === "changePassword" && <FingerIcon className={styles.logo} />}
                    {authState.status === "signUp" && <SignUpIcon2 className={styles.logo} />}
                    {authState.status === "otp" && <SmsIcon className={styles.logo} />}
                </div>
            </div>
        </BackLayout>

    )
}
export default Auth